import type { BuilderApiAdapter, BuilderAsset } from '@printtat/builder';
import { designsApi } from '@/services/designsApi';
import { productsApi } from '@/services/productsApi';
import { assetsApi, type Asset, type AssetListParams } from '@/services/assetsApi';

const toBuilderAsset = (asset: Asset): BuilderAsset => ({
  id: asset.id,
  name: asset.name,
  url: asset.url,
  originalName: asset.originalName,
  mimeType: asset.mimeType,
  width: asset.width,
  height: asset.height,
  hasTransparency: asset.hasTransparency,
  source: asset.source,
  uploadedByUserId: asset.uploadedByUserId,
  uploadedBy: asset.uploadedBy,
  categoryId: asset.categoryId,
  categoryName: asset.categoryName,
});

const isAssetSource = (value: string | undefined): value is 'user' | 'printtat' =>
  value === 'user' || value === 'printtat';

export const frontendBuilderApi: BuilderApiAdapter = {
  getDesign: (id) => designsApi.get(id),
  createDesign: (data) => designsApi.create(data),
  updateDesign: async (id, data) => {
    await designsApi.update(id, data);
  },
  uploadSurfaceExport: (file, designId) =>
    designsApi.uploadSurfaceExport(file, designId),
  getProduct: (id) => productsApi.getProduct(id),
  listAssets: async (params) => {
    const normalized: AssetListParams = {
      source: isAssetSource(params.source) ? params.source : undefined,
      category: params.category,
      search: params.search,
      page: params.page,
      limit: params.limit,
    };
    const result = await assetsApi.listPaginated(normalized);
    return {
      data: result.data.map(toBuilderAsset),
      meta: result.meta,
    };
  },
  listAssetCategories: () => assetsApi.listCategories(),
  uploadAsset: async (file, meta) => toBuilderAsset(await assetsApi.upload(file, meta)),
  deleteAsset: (id, force) => assetsApi.delete(id, force),
  renameAsset: async (id, name) => toBuilderAsset(await assetsApi.rename(id, name)),
};
